import { render, staticRenderFns } from "./POIImagePreview.vue?vue&type=template&id=3ff0c542"
import script from "./POIImagePreview.js?vue&type=script&lang=js&external"
export * from "./POIImagePreview.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports